
    import {
        defineComponent, PropType, toRefs,
    } from 'vue';
    import { formatNumber } from '@ve/services/textModifiers';
    import { IReturnProductType } from '@ve/pages/hotel/types';
    import useProductText from '@ve/pages/hotel/use/useProductText';

    export default defineComponent({
        props: {
            product: {
                type: Object as PropType<IReturnProductType>,
                required: true,
            },
            isActive: {
                type: Boolean,
                default: false,
            },
        },
        setup(props) {
            const { product } = toRefs(props);

            const { productTextByType } = useProductText(product);
            return {
                productTextByType,
                formatNumber,
            };
        },
    });
